<div class="filter-container container">
  <div>
    <div>{{ 'label.From' | translate }}</div>
    <p-datepicker
      [showIcon]="true"
      [(ngModel)]="filterPagingWrapper.filter.createDate.from"
    ></p-datepicker>
  </div>
  <div>
    <div>{{ 'label.To' | translate }}</div>
    <p-datepicker
      [showIcon]="true"
      [(ngModel)]="filterPagingWrapper.filter.createDate.to"
    ></p-datepicker>
  </div>
  <div>
    <div>{{ 'label.Customer' | translate }}</div>
    <div>
      <input
        type="text"
        [(ngModel)]="filterPagingWrapper.filter.customerCredential"
      />
    </div>
  </div>
  <div>
    <div>{{ 'label.AccountManager' | translate }}</div>
    <div>
      <select
        [ngModel]="
          accountManagers && filterPagingWrapper.filter.accountManagerId
        "
        (ngModelChange)="
          accountManagers &&
            (filterPagingWrapper.filter.accountManagerId = $event)
        "
      >
        <option selected></option>
        <option *ngFor="let item of accountManagers" [value]="item?.adminId">
          {{ item?.fullName }}
        </option>
      </select>
    </div>
  </div>
  <div>
    <div>
      {{ 'label.TotalDebt' | translate }} {{ 'label.From' | translate }} -
      {{ 'label.To' | translate }}
    </div>
    <div>
      <input
        type="number"
        [(ngModel)]="filterPagingWrapper.filter.totalDebt.from"
      />
      <span> - </span>
      <input
        type="number"
        [(ngModel)]="filterPagingWrapper.filter.totalDebt.to"
      />
    </div>
  </div>
  <div>
    <p-checkbox
      [(ngModel)]="filterPagingWrapper.filter.hideZeroDebtCustomer"
      binary="true"
      inputId="chk-hideZeroDebtCustomer"
    ></p-checkbox>
    <label for="chk-hideZeroDebtCustomer">{{
      'label.HideZeroDebtCustomer' | translate
    }}</label>
  </div>
  <div>
    <button class="apply" (click)="onApplyFilter()">
      {{ 'label.Filter' | translate }}
    </button>
    <button class="clear" (click)="onClearFilter()">
      {{ 'label.Clear' | translate }}
    </button>
  </div>
</div>
<div>
  <hr-thread-post-editor
    [threadId]="displayedOrEditingThreadId"
    [objectTypeId]="ThreadRelatedObjectTypeEnum.Customer"
    [objectId]="editingThreadObjectId"
    [topicId]="displayedOrEditingThreadTopic"
    [channelId]="PostingChannelEnum.ACC"
    [display]="displayThreadPostEditor"
    (onUpdate)="onUpdateTable($event)"
  ></hr-thread-post-editor>
  <hr-thread-view
    [threadId]="displayedOrEditingThreadId"
    [display]="displayThread"
    [topicId]="displayedOrEditingThreadTopic"
    (onClose)="onThreadClose($event)"
    (onDeleteComment)="onPostDelete($event)"
  ></hr-thread-view>
  <p-table
    [value]="customers"
    showGridlines
    [lazy]="true"
    [paginator]="true"
    [rows]="pageSize"
    (onLazyLoad)="onLoad($event)"
    [totalRecords]="totalRecords"
    [responsive]="true"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th [pSortableColumn]="'customerName'">
          {{ 'label.Company' | translate }}
          <p-sortIcon
            [field]="'customerName'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th>
          {{ 'label.AccountManager' | translate }}
        </th>
        <th [pSortableColumn]="'totalInvoiceAmount'">
          {{ 'label.TotalInvoiceAmount' | translate }}
          <p-sortIcon
            [field]="'totalInvoiceAmount'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th [pSortableColumn]="'totalPaymentAmount'">
          {{ 'label.TotalPaymentAmount' | translate }}
          <p-sortIcon
            [field]="'totalPaymentAmount'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th [pSortableColumn]="'currentDebt'">
          {{ 'label.CurrentDebt' | translate }}
          <p-sortIcon
            [field]="'currentDebt'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th [pSortableColumn]="'oldDebt'">
          {{ 'label.OldDebt' | translate }}
          <p-sortIcon
            [field]="'oldDebt'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th [pSortableColumn]="'totalDebt'">
          {{ 'label.TotalDebt' | translate }}
          <p-sortIcon
            [field]="'totalDebt'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th [pSortableColumn]="'threadTopic,' + ThreadTopicEnum.ACC">
          {{ 'label.ACC' | translate }}
          <p-sortIcon
            [field]="'threadTopic,' + ThreadTopicEnum.ACC"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th [pSortableColumn]="'threadTopic,' + ThreadTopicEnum.Debt">
          {{ 'label.DC' | translate }}
          <p-sortIcon
            [field]="'threadTopic,' + ThreadTopicEnum.Debt"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th [pSortableColumn]="'threadTopic,' + ThreadTopicEnum.ACC">
          {{ 'label.ACC/Sales' | translate }}
          <p-sortIcon
            [field]="'threadTopic,' + ThreadTopicEnum.ACC"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template
      pTemplate="body"
      let-customer
      let-expanded="expanded"
      let-columns="columns"
    >
      <tr [ngClass]="getRowStyleClass(customer)">
        <td>
          <a [routerLink]="['/customers/view', customer?.customerId]">{{
            customer.customerName
          }}</a
          ><br />
          <span>{{ customer.customerTaxCode }}</span
          ><br />
          <span>{{ customer.customerVatStatusName }}</span>
        </td>
        <td>
          <span>{{ customer.accountManagerName }}</span>
        </td>
        <td>
          <a
            [routerLink]="[
              '/billing/invoices/list',
              { customer: customer?.customerTaxCode }
            ]"
            target="_blank"
            >{{ customer.totalInvoiceAmount | number : decimalFormat }}</a
          >
        </td>
        <td>
          <a
            [routerLink]="[
              '/billing/payments/list',
              { customer: customer?.customerTaxCode }
            ]"
            target="_blank"
            >{{ customer.totalPaymentAmount | number : decimalFormat }}</a
          >
        </td>
        <td>
          <a
            [routerLink]="[
              '/billing/invoices/list',
              { status: '1', customer: customer?.customerTaxCode }
            ]"
            target="_blank"
            >{{ customer.currentDebt | number : decimalFormat }}</a
          >
        </td>
        <td>
          {{ customer.oldDebt | number : decimalFormat }}
        </td>
        <td>
          {{ customer.totalDebt | number : decimalFormat }}
        </td>

        <td>
          <span
            class="comment"
            (click)="
              showThread(customer.lastAccComment?.threadId, ThreadTopicEnum.ACC)
            "
          >
            {{ customer.lastAccComment?.text }}
          </span>
          <span class="date">{{
            customer.lastAccComment?.createDate | date : dateFormat
          }}</span>
          <p-button
            type="button"
            class="addComment"
            icon="fa fa-plus-circle"
            (click)="
              showCommentEditor(
                customer.lastAccComment?.threadId,
                customer.customerId,
                ThreadTopicEnum.ACC
              )
            "
          >
          </p-button>
        </td>

        <td>
          <span
            class="comment"
            (click)="
              showThread(
                customer.lastDebtComment?.threadId,
                ThreadTopicEnum.Debt
              )
            "
          >
            {{ customer.lastDebtComment?.text }}
          </span>
          <span class="date">{{
            customer.lastDebtComment?.createDate | date : dateFormat
          }}</span>
          <p-button
            type="button"
            class="addComment"
            icon="fa fa-plus-circle"
            (click)="
              showCommentEditor(
                customer.lastDebtComment?.threadId,
                customer.customerId,
                ThreadTopicEnum.Debt
              )
            "
          ></p-button>
        </td>

        <td>
          <span
            class="comment"
            (click)="
              showThread(
                customer.lastSalesAccComment?.threadId,
                ThreadTopicEnum.ACC
              )
            "
          >
            {{ customer.lastSalesAccComment?.text }}
          </span>
          <span class="date">{{
            customer.lastSalesAccComment?.createDate | date : dateFormat
          }}</span>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer" let-columns>
      <tr>
        <td>{{ totalRecords }}</td>
        <td></td>
        <td>{{ listTotals?.invoicesTotal | number : decimalFormat }}</td>
        <td>{{ listTotals?.paymentsTotal | number : decimalFormat }}</td>
        <td>{{ listTotals?.currentDebtSum | number : decimalFormat }}</td>
        <td>{{ listTotals?.oldDebtSum | number : decimalFormat }}</td>
        <td>{{ listTotals?.totalDebtSum | number : decimalFormat }}</td>
        <td colspan="3"></td>
      </tr>
    </ng-template>

    <!-- <p-column header="{{'Company' | translate}}" field="customerName" [sortable]="true">
      <ng-template let-col let-customer="rowData" pTemplate="body">
        <a [routerLink]="['/customers/view',customer?.customerId]">{{customer.customerName}}</a><br>
        <span>{{customer.customerTaxCode}}</span><br>
        <span>{{customer.customerVatStatusName}}</span>
      </ng-template>
    </p-column>
    <p-column header="{{'AccountManager' | translate}}">
    <ng-template let-col let-customer="rowData" pTemplate="body">
        <span>{{customer.accountManagerName}}</span>
    </ng-template>
    </p-column>
    <p-column header="{{'TotalInvoiceAmount' | translate}}" field="totalInvoiceAmount" [sortable]="true">
      <ng-template let-col let-customer="rowData" pTemplate="body">
        <a [routerLink]="['/billing/invoices/list', {customer: customer?.customerTaxCode}]" target="_blank">{{customer.totalInvoiceAmount | number:decimalFormat}}</a>
      </ng-template>
    </p-column>
    <p-column header="{{'TotalPaymentAmount' | translate}}" field="totalPaymentAmount" [sortable]="true">
      <ng-template let-col let-customer="rowData" pTemplate="body">
          <a [routerLink]="['/billing/payments/list', {customer: customer?.customerTaxCode}]" target="_blank">{{customer.totalPaymentAmount | number:decimalFormat}}</a>
      </ng-template>
    </p-column>
    <p-column header="{{'CurrentDebt' | translate}}"  field="currentDebt" [sortable]="true">
      <ng-template let-col let-customer="rowData" pTemplate="body">
          <a [routerLink]="['/billing/invoices/list', {status: '1', customer: customer?.customerTaxCode}]" target="_blank">{{customer.currentDebt | number:decimalFormat}}</a>
      </ng-template>
    </p-column>
    <p-column header="{{'OldDebt' | translate}}"  field="oldDebt" [sortable]="true">
      <ng-template let-col let-customer="rowData" pTemplate="body">
        {{customer.oldDebt | number:decimalFormat}}
      </ng-template>
    </p-column>
    <p-column header="{{'TotalDebt' | translate}}"  field="TotalDebt" [sortable]="true">
      <ng-template let-col let-customer="rowData" pTemplate="body">
        {{customer.totalDebt | number:decimalFormat}}
      </ng-template>
    </p-column>
    <p-column header="{{'ACC' | translate}}" field="{{'threadTopic,' + ThreadTopicEnum.ACC}}" [sortable]="true">
      <ng-template let-col let-customer="rowData" pTemplate="body">
        <span class='comment' (click)="showThread(customer.lastAccComment?.threadId, ThreadTopicEnum.ACC)">
          {{customer.lastAccComment?.text}}
        </span>
        <span>{{customer.lastAccComment?.createDate | date:dateFormat}}</span>
        <p-button type="button" class="addComment" icon="fa fa-plus-circle"
          (click)="showCommentEditor(customer.lastAccComment?.threadId, customer.customerId, ThreadTopicEnum.ACC)"></p-button>
      </ng-template>
    </p-column>
    <p-column header="{{'DC' | translate}}" field="{{'threadTopic,' + ThreadTopicEnum.Debt}}" [sortable]="true" >
      <ng-template let-col let-customer="rowData" pTemplate="body">
        <span class='comment' (click)="showThread(customer.lastDebtComment?.threadId, ThreadTopicEnum.Debt)">
          {{customer.lastDebtComment?.text}}
        </span>
        <span>{{customer.lastDebtComment?.createDate | date:dateFormat}}</span>
        <p-button type="button" class="addComment" icon="fa fa-plus-circle"
          (click)="showCommentEditor(customer.lastDebtComment?.threadId, customer.customerId, ThreadTopicEnum.Debt)"></p-button>
      </ng-template>
    </p-column>
    <p-column header="{{'ACC/Sales' | translate}}" field="{{'threadTopic,' + ThreadTopicEnum.ACC}}" [sortable]="true">
      <ng-template let-col let-customer="rowData" pTemplate="body">
        <span class='comment' (click)="showThread(customer.lastSalesAccComment?.threadId, ThreadTopicEnum.ACC)">
          {{customer.lastSalesAccComment?.text}}
        </span>
        <span>{{customer.lastSalesAccComment?.createDate | date:dateFormat}}</span>
      </ng-template>
    </p-column> -->
    <!-- <p-footerColumnGroup>
        <p-row>
            <p-column footer="{{totalRecords}}"></p-column>
            <p-column></p-column>
            <p-column footer="{{listTotals?.invoicesTotal | number:decimalFormat}}"></p-column>
            <p-column footer="{{listTotals?.paymentsTotal | number:decimalFormat}}"></p-column>
            <p-column footer="{{listTotals?.currentDebtSum | number:decimalFormat}}"></p-column>
            <p-column footer="{{listTotals?.oldDebtSum | number:decimalFormat}}"></p-column>
            <p-column footer="{{listTotals?.totalDebtSum | number:decimalFormat}}"></p-column>
            <p-column colspan="3"></p-column>
        </p-row>
    </p-footerColumnGroup> -->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="10">
          {{ 'message.NoRecordsFound' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
